import Events from "./Components/Core/Events";
import Forms from "./Components/Forms/forms";
import {favoritesInit, favoritesInitItem} from "./Components/Favorites/favorites";
import {compareInit, compareInitItem} from "./Components/Compare/compare";
import Locations from './Components/Locations/locations';
import {cartInfoInit} from "./Components/basket/updateCartInfo";
import MmenuLight from "mmenu-light";
import Agent from "./Components/Core/agent";
import {searchAutocomplete} from "./Components/Search/search";
import {notice} from "./Components/UI/notice";
import AuthApi from "./Components/Api/AuthApi";
import {modal} from "./Components/UI/modal";
import {empty} from "./Components/Core/common";
import Choices from "choices.js";

const events = new Events();

cartInfoInit(events);

const form = new Forms(events);
let locations = new Locations(events);

document.querySelectorAll('.geo_location').forEach(item => item.addEventListener('click', () => {
    locations.getLocations(item);
}));

favoritesInit('.js_add_favorites', events);
compareInit('.js_add_compare', events);


let initBasket;
if (document.querySelector('.js_add_to_cart')) {
    if (!initBasket) {
        initBasket = async () => await import("./Components/basket/basket");
    }

    initBasket()
        .then(f => f.initBasketEvents('.js_add_to_cart', events));
}
(function () {
    function decimalAdjust(type, value, exp) {
        // Если степень не определена, либо равна нулю...
        if (typeof exp === "undefined" || +exp === 0) {
            return Math[type](value);
        }
        value = +value;
        exp = +exp;
        // Если значение не является числом, либо степень не является целым числом...
        if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0)) {
            return NaN;
        }
        // Сдвиг разрядов
        value = value.toString().split("e");
        value = Math[type](+(value[0] + "e" + (value[1] ? +value[1] - exp : -exp)));
        // Обратный сдвиг
        value = value.toString().split("e");
        return +(value[0] + "e" + (value[1] ? +value[1] + exp : exp));
    }

// Десятичное округление к ближайшему
    if (!Math.round10) {
        Math.round10 = function (value, exp) {
            return decimalAdjust("round", value, exp);
        };
    }
// Десятичное округление вниз
    if (!Math.floor10) {
        Math.floor10 = function (value, exp) {
            return decimalAdjust("floor", value, exp);
        };
    }
// Десятичное округление вверх
    if (!Math.ceil10) {
        Math.ceil10 = function (value, exp) {
            return decimalAdjust("ceil", value, exp);
        };
    }
})
();


let reInitBasket;
events.addListener('filter.search', null, () => {
    document.querySelectorAll('.js_add_favorites').forEach(item => favoritesInitItem(item));
    document.querySelectorAll('.js_add_compare').forEach(item => compareInitItem(item));
    if (!reInitBasket) {
        if (!initBasket) {
            initBasket = async () => await import("./Components/basket/basket");
        }

        initBasket().then(f => {
            reInitBasket = f.reInitBasketEvents;
            reInitBasket('.js_add_to_cart', events);
        });
    } else {
        reInitBasket('.js_add_to_cart', events);
    }

    let filterBlock = document.querySelector('.js_filter_result, .js_load_favorites');

    form.initModalForm(document);

    document.querySelectorAll('.product-item').forEach(item => {
        if (!item.classList.contains('btn-char-initialized')) {
            item.classList.add('btn-char-initialized');
            let btn_char = item.querySelector('.btn-char');
            if (btn_char) {
                btn_char.addEventListener('click', () => {
                    item.querySelector('.flip-container').classList.toggle('active');
                });
            }
            let flip_close = item.querySelector('.flip-close');
            if (flip_close) {
                flip_close.addEventListener('click', () => {
                    item.querySelector('.flip-container').classList.remove('active');
                });
            }
        }
    });
});

if (document.querySelector('.js_filter_form')) {
    const filter = async () => await import("./Components/Filter/filter");
    filter().then(f => f.init(events));
}

let mobile_menu = document.querySelector("#mobile-menu");
if (mobile_menu) {
    let mobileMenu = new MmenuLight(mobile_menu);
    mobileMenu.navigation({
        title: "Меню",
        theme: "dark",
    });
    let drawerMenu = mobileMenu.offcanvas();
    document.querySelector('a[href="#mobile-menu"]').addEventListener('click', function (evnt) {
        evnt.preventDefault();
        drawerMenu.open();
    });

    events.addListener('form_success_submitted', null, () => drawerMenu.close());
}


if (document.querySelector('input[type="tel"]')) {
    let phoneFormatter = async () => await import('./Components/phone');
    phoneFormatter().then(e => e.init());
}

if (document.querySelector('.scroll-item')) {
    document.addEventListener('scroll', () => {
        if (window.pageYOffset > 300) {
            document.querySelectorAll('.scroll-item').forEach(item => {
                item.classList.add('active');
            });
        } else {
            document.querySelectorAll('.scroll-item').forEach(item => {
                item.classList.remove('active');
            });
        }
    });
    document.querySelector('.scroll-item').addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
}

if (document.querySelector('.category-filter')) {
    let btn = document.querySelector('.btn-filter');
    let filter = document.querySelector('.category-filter');
    document.addEventListener('click', (e) => {
        if (filter.classList.contains('active')) {
            if (e.target === filter) {
                filter.classList.remove('active');
            }
        }
    });
    btn.addEventListener('click', () => {
        filter.classList.add('active');
    });
}

const loadViewed = document.querySelector('.viewed');
if (loadViewed) {
    let observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                if (!loadViewed.querySelector('div')) {
                    Agent.post(`/api/v1/viewed`)
                        .then(e => e.json())
                        .then(e => {
                            if (e.success) {
                                loadViewed.innerHTML = e.data;
                                events.dispatch('filter.search');
                            }
                        })
                        .catch(e => console.log(e))
                        .finally(() => {
                            obs.unobserve(entry.target);
                        });
                }
            }
        });
    });

    observer.observe(loadViewed);
}


searchAutocomplete.init(events);


document.querySelectorAll('.js_open_autorize_form').forEach(item => item.addEventListener('click', () => {
    const options = {
        header: function () {
            return `<div class="modal-header"><div class="fs-lg-24 fs-sm-20 fs-18 lh-0_9 mb-0 fw-bl">Вход в личный кабинет</div>
                <button class="btn-close position-absolute end-0 top-0 mt-10 me-10 border-0 p-0 ms-auto d-flex p-10 bg-transparent" data-bs-dismiss="modal">
                <i class="icon u_multiply fs-sm-24 fs-20 text-main"></i>
                </button></div>`;
        },
        'size': 'modal-dialog-centered',
        message: `
                <div class="modal-form gap-20 d-flex flex-column">
                    <p class="lh-1_3 fw-rg fs-sm-14 fs-12">Укажите номер телефона</p>
                    <form class="d-flex flex-column gap-20" name='authorization' method='post' autocomplete="off">
                        <div class="d-flex flex-column gap-10">
                            <label class="main-input d-flex align-items-center pointer-text flex-grow-1 position-relative">
                                <input class="input-phone w-100 p-md-20 p-sm-15 p-10 fs-12 fs-sm-16 lh-1 flex-grow-1" type="tel" name="phone" placeholder="8 (9__) ___-__-__" required>
                                <i class="icon u_phone-alt fs-20 d-none d-sm-block me-md-20 me-15"></i>
                            </label>
                            <button 
                                    class="btn-main px-15 py-10 px-sm-20 px-md-30 py-sm-20 fs-12 fs-sm-14 fs-md-16 lh-1 fw-bl flex-grow-1 js_recover_password"
                                    type="button"
                            >
                                    Получить код
                            </button>
                        </div>
                        <div class="d-flex flex-column gap-20">
                            <p class="lh-1_3 fw-rg fs-sm-14 fs-12">Укажите sms-код</p>
                            <div class="d-flex flex-column gap-10">
                                <label class="main-input d-flex align-items-center pointer-text flex-grow-1 position-relative">
                                    <input class="input-phone w-100 p-md-20 p-sm-15 p-10 fs-12 fs-sm-16 lh-1 flex-grow-1" type="password" placeholder="____" name="password" required>
                                </label>
                                <button class="btn-main px-15 py-10 px-sm-20 px-md-30 py-sm-20 fs-12 fs-sm-14 fs-md-16 lh-1 fw-bl flex-grow-1 js_auth_button">Войти</button>
                            </div>
                        </div>
                        <div class="message w-100 d-flex justify-content-center">
                            <span class="fw-regular fs-14 text-danger js_message_label"></span>
                            <span class="fw-regular fs-14 text-danger js_message_sms_label d-none"> </span>
                        </div>
                    </form>
                </div>`,
        showEvent: function (to) {

            let inputPhone = to.querySelector('input[name="phone"]');
            let inputPassword = to.querySelector('input[name="password"]');
            let js_recover_password = to.querySelector('.js_recover_password');

            let js_message_label = to.querySelector('.js_message_label');
            let js_message_sms_label = to.querySelector('.js_message_sms_label');
            let form = to.querySelector('form');
            let js_auth_button = to.querySelector('.js_auth_button');

            const authorization = function () {
                js_message_label.innerHTML = '';

                let userName = inputPhone.value.trim().replace(/[^0-9]/g, '');
                let password = inputPassword.value.trim();

                if (empty(userName) || empty(password)) {
                    notice("Необходимо заполнить<br> обязательные поля.");
                    return;
                }

                AuthApi.authorization(userName, password)
                    .then(response => response.json())
                    .then(response => {
                        if (response.success) {
                            if (response.url) {
                                document.location.href = response.url;
                            } else {
                                document.location.reload();
                            }
                        } else {
                            js_message_label.innerHTML = response.message;
                        }
                    })
                    .catch(() => {
                        notice("Не удалось сменить пароль.<br> Попробуйте позже <br>или<br> обратитесь к администратору.");
                    });
            };

            const timer = (timerPeriod, start, tick, finish) => {
                let counter = timerPeriod || 1;
                if (typeof start === 'function') {
                    start();
                }
                if (typeof tick === 'function') {
                    tick(counter);
                }
                let smsTimer = setInterval(function () {
                    counter--;
                    if (typeof tick === 'function') {
                        tick(counter);
                    }
                    if (counter === 0) {
                        counter = timerPeriod;
                        clearInterval(smsTimer);
                        if (typeof finish === 'function') {
                            finish();
                        }
                    }
                }, 1000);
            };

            const smsTimer = seconds => {
                timer(parseInt(seconds), function () {
                    js_recover_password.disabled = true;
                    js_message_sms_label.classList.remove('d-none');
                }, function (secondsLeft) {
                    js_message_sms_label.innerHTML = `Пароль был выслан на указанный номер. <br>Следующая отправка СМС возможна через <b>${secondsLeft}</b> секунд`;
                }, function () {
                    js_recover_password.disabled = false;
                    js_message_sms_label.classList.add('d-none');
                });
            };

            const recover_password = function () {

                let phone = inputPhone.value.trim().replace(/[^0-9]/g, '');
                if (empty(phone)) {
                    notice("Необходимо заполнить<br> обязательные поля.");
                } else {
                    js_recover_password.classList.add('preloader');
                    AuthApi.recoverPassword(phone)
                        .then(response => response.json())
                        .then(response => {
                            if (response.message && !response.seconds) {
                                js_message_label.innerHTML = response.message;
                            }
                            if (response.seconds) {
                                smsTimer(response.seconds);
                            }
                        })
                        .catch(() => {
                            notice("Не удалось отправить пароль.<br> Попробуйте позже<br> или<br> обратитесь к администратору.");
                        })
                        .finally(() => {
                            js_recover_password.classList.remove('preloader');
                        });
                }
            };


            inputPhone.addEventListener('input', () => {
                js_message_label.innerHTML = '';
            });

            js_auth_button.addEventListener('click', () => {
                js_message_label.innerHTML = '';

                if (inputPassword.value.trim().length > 3) {
                    authorization();
                }
            });

            js_recover_password.addEventListener('click', () => {
                js_message_label.innerHTML = '';
                recover_password();
            });

            form.addEventListener('submit', event => {
                event.stopPropagation();
                event.preventDefault();
            });
        }
    };

    modal(options);
}));


if (document.querySelector('.header-mid')) {
    function headerFixed() {
        const headerF = document.querySelector('.header-mid');
        if (window.scrollY > 180) {
            headerF.classList.add('header-mid_fixed')
        }
        document.addEventListener('scroll', function () {
            if (window.scrollY > 180) {
                headerF.classList.add('header-mid_fixed');
            } else {
                headerF.classList.remove('header-mid_fixed');
            }
        })
    }

    headerFixed()
}

document.querySelectorAll('.dropdawn').forEach(item => {
    item.addEventListener("mouseover", function () {
        item.querySelector('.dropdawn-btn').classList.add('active');
        item.querySelector('.dropdawn-menu').classList.add('active');
    });
    item.addEventListener("mouseleave", function () {
        let timer = setTimeout(function () {
            item.querySelector('.dropdawn-menu').classList.remove('active');
            item.querySelector('.dropdawn-btn').classList.remove('active');
        }, 100);
        item.addEventListener('mouseover', function () {
            item.querySelector('.dropdawn-btn').classList.add('active');
            item.querySelector('.dropdawn-menu').classList.add('active');
            clearTimeout(timer);
        });
    });
});

if (document.querySelector('.category-filter')) {
    let btn = document.querySelector('.btn-filter');
    const filter = document.querySelector('.category-filter');
    const wrapper = filter.querySelector('.category-wrapper');
    const body = document.querySelector('body');
    document.addEventListener('click', (e) => {
        if (filter.classList.contains('active')) {
            if (e.target == filter) {
                filter.classList.remove('active');
                body.classList.remove('mm-ocd-opened');
            }
        }
    });
    if (btn) {
        btn.addEventListener('click', () => {
            filter.classList.add('active');
            body.classList.add('mm-ocd-opened');
        });
    }

    let parameters = filter.querySelectorAll('label input');
    let button = document.createElement('button');
    button.classList.add('category-filter__float-btn');
    button.setAttribute("data-label", 'Показать');
    let hideTimer = null;

    function hideButton() {
        button.removeEventListener('click', eventClickButton);
        button.remove();
        clearTimeout(hideTimer);
        hideTimer = null;
    }

    function showButton(item) {
        hideTimer ? clearTimeout(hideTimer) : wrapper.appendChild(button);
        hideTimer = setTimeout(hideButton.bind(this), 5000);
        let paramL = item.target.closest('label');
        let t = paramL.offsetTop;
        let top
        top = t - ((button.clientHeight / 2) - (paramL.clientHeight / 2));
        button.style.top = top + 'px';
        button.addEventListener('click', eventClickButton);
    }

    const eventClickButton = () => {
        const js_filter2_button = document.querySelector('.js_filter2_button');
        if (js_filter2_button) {
            js_filter2_button.dispatchEvent(new Event('click'));
            hideButton();
        }
    };

    parameters.forEach(param => {
        if (param.attributes.type.value === 'checkbox') {
            param.addEventListener('change', function (e) {
                showButton(e);
            })
        }
        if (param.attributes.type.value === 'number') {
            param.addEventListener('input', function (e) {
                showButton(e);

            })
        }

    })
}
;

document.querySelectorAll("[data-id='section-filter']").forEach(filter => {
    let city = filter.querySelector("#city");
    let cityChoice = null;
    if (city) {
        cityChoice = new Choices(city, {
            itemSelectText: '',
            position: 'bottom',
            searchEnabled: false,
        });
    }


    filter.querySelectorAll('[name="heat_region"]').forEach(item => item.addEventListener('change', () => {

        Agent.post(`/api/v1/heat/city/${item.value}`)
            .then(e => e.json())
            .then(e => {
                if (e.success) {
                    if (city) {
                        cityChoice.clearChoices();
                        cityChoice.clearInput();
                        cityChoice.setChoices([...e.data.map(item => {
                            return {'value': item.id, 'label': item.name}
                        })]);

                        city.dispatchEvent(new Event('change'));
                        // city.trigger('change');
                    }
                } else {
                    notice(e.message);
                }
            })
            .catch(e => console.log(e));
    }));

    filter.querySelectorAll("[name='is_building_basement']")
        .forEach(item => item.addEventListener('change', () => {
            filter.querySelector("[name='building_basement']").disabled = (+item.value === 0);
        }));

    filter.querySelectorAll("#btn-heat").forEach(item => item.addEventListener('click', () => {
        item.classList.add('preloader');
        item.disabled = true;

        const formData = new FormData();
        formData.append('city', city.value);
        formData.append('v', filter.querySelector("#V").value);
        formData.append('type_of_fuel', filter.querySelector("[name='fuel']").value);
        formData.append('construction', filter.querySelector('[name="construction"]').value);
        formData.append('type', item.dataset.id || 1);

        formData.append('building_basement', filter.querySelector("[name='building_basement']").value);


        let js_power_calculation_result = filter.querySelector('.js_power_calculation_result');
        js_power_calculation_result.innerHTML = '';

        Agent.post(`/api/v1/heat/find/`, formData)
            .then(e => e.json())
            .then(e => {
                if (e.success) {
                    if (e.count) {
                        js_power_calculation_result.innerHTML = `<h3 class="fw-md fs-md-35 fs-24 lh-1_2 mb-0">Вам подойдут котлы мощностью: <span>${e.qmax.power_kvt} кВт / ${e.qmax.power_ggal} Гкал / ${e.qmax.power_mvt} МВт</span></h3>
                <div class="choosing-result__wrapper d-flex flex-column gap-20">
                    <div class="choosing-result__grid">
                        ${e.data}
                    </div>
                </div>`;

                    } else {
                        js_power_calculation_result.innerHTML = `<h3 class="fw-md fs-md-35 fs-24 lh-1_2 mb-0">Вам подойдут котлы мощностью: <span>${e.qmax.power_kvt} кВт / ${e.qmax.power_ggal} Гкал / ${e.qmax.power_mvt} МВт</span></h3>
                <div class="choosing-result__wrapper d-flex flex-column gap-20">
                    
                        ${e.data}
                    
                </div>`;
                    }

                    events.dispatch('filter.search');
                } else {
                    notice(e.message);
                }
            })
            .catch(e => console.log(e))
            .finally(() => {
                item.classList.remove('preloader');
                item.disabled = false;
            });
    }));
});


export default events;